import React, { useState, useEffect } from "react";
import MainLayout from "../layouts/MainLayout";

import Logo from "../images/header/Logo Trato.svg";
import "../scss/IA.scss";
import alta from "../images/Claridad Alta.svg";
import media from "../images/La respuesta varía.svg";
import baja from "../images/Claridad Baja.svg";
import { useTranslation } from "react-i18next";

function IACover({ analysis, header }) {
  const { t } = useTranslation("common");
  const { tipo } = analysis;
  const getData = (name) => {
    const items = Object.entries(analysis).filter((x) =>
      x?.[0].slice(0, name.length).includes(name)
    );
    if (items.length > 0) {
      return items.map((item) => <p className="font-weight-bold">{item[1]}</p>);
    }
    if (items.length === 0) {
      return <NA />;
    }
  };

  return (
    <div>
      {header && (
        <div className="IACover--header__one">
          <h2 className="font-weight-bold">{t("common:IACover.title")}</h2>
        </div>
      )}

      {tipo === "arrendamiento" ? (
        <div className="IACover">
          <div>
            <div className="IACover--info" id="IACover--pic1">
              <div className="IACover--header">
                <h3>{t("common:IACover.subtitle")}</h3>
                <img src={Logo} />
              </div>

              <div className="row1">
                <div className="info1">
                  <div className="item">
                    <p className="font-weight-bold">
                      {t("common:IACover.text.0")}
                    </p>
                    <div style={{ display: "flex", flexFlow: "column" }}>
                      {getData("tipo")}
                    </div>
                  </div>
                </div>
                <div className="info2">
                  <div className="item">
                    <p>{t("common:IACover.arrendamiento.1")}</p>
                    <span className="font-weight-bold">
                      <div style={{ display: "flex", flexFlow: "column" }}>
                        {getData("fecha_firma")}
                      </div>
                    </span>
                  </div>
                  <div className="item">
                    <p>{t("common:IACover.arrendamiento.2")}</p>
                    <div style={{ display: "flex", flexFlow: "column" }}>
                      {getData("donde_se_firma")}
                    </div>
                  </div>
                </div>
              </div>
              <div className="row--contractParts">
                <p className="font-weight-bold">
                  {t("common:IACover.arrendamiento.2")}
                </p>
                <div className="info">
                  <div className="item">
                    <div className="col1">
                      <p>{t("common:IACover.arrendamiento.4")}</p>
                      <div style={{ display: "flex", flexFlow: "column" }}>
                        {getData("arrendador")}
                      </div>
                    </div>
                    <div className="col2">
                      <p>{t("common:IACover.arrendamiento.6")}</p>
                      <div style={{ display: "flex", flexFlow: "column" }}>
                        {getData("rep_arrendador")}
                      </div>
                    </div>
                  </div>
                  <div className="item">
                    <div className="col1">
                      <p>{t("common:IACover.arrendamiento.5")}</p>
                      <div style={{ display: "flex", flexFlow: "column" }}>
                        {getData("arrendatario")}
                      </div>
                    </div>
                    <div className="col2">
                      <p>{t("common:IACover.arrendamiento.7")}</p>
                      <div style={{ display: "flex", flexFlow: "column" }}>
                        {getData("rep_arrendatario")}
                      </div>
                    </div>
                  </div>
                  <div className="item">
                    <div className="col1">
                      <p>{t("common:IACover.arrendamiento.19")}</p>
                      <div style={{ display: "flex", flexFlow: "column" }}>
                        {getData("obligado_solidario")}
                      </div>
                    </div>
                    <div className="col2">
                      <p>{t("common:IACover.arrendamiento.20")}</p>
                      <div style={{ display: "flex", flexFlow: "column" }}>
                        {getData("rep_obligado_solidario")}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="row--normal">
                <div className="info">
                  <div className="item item--adress">
                    <p className="font-weight-bold">
                      {t("common:IACover.arrendamiento.8")}
                    </p>

                    <div style={{ display: "flex", flexFlow: "column" }}>
                      {getData("dir_inmueble")}
                    </div>
                  </div>
                  <div className="item">
                    <p className="font-weight-bold">
                      {t("common:IACover.arrendamiento.9")}
                    </p>

                    <div style={{ display: "flex", flexFlow: "column" }}>
                      {getData("renta")}
                    </div>
                  </div>
                  <div className="item">
                    <p className="font-weight-bold">
                      {t("common:IACover.arrendamiento.10")}
                    </p>

                    <div style={{ display: "flex", flexFlow: "column" }}>
                      {getData("plazo_renta")}
                    </div>
                  </div>
                </div>
              </div>
              <div className="row--normal">
                <p className="font-weight-bold">
                  {t("common:IACover.arrendamiento.11")}
                </p>
                <div className="info">
                  <div className="item">
                    <p>{t("common:IACover.arrendamiento.12")}</p>
                    <span className="font-weight-bold">
                      <div style={{ display: "flex", flexFlow: "column" }}>
                        {getData("inicio_renta")}
                      </div>
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <div id="IACover--pic2">
              <div className="row--normal">
                <p className="font-weight-bold">
                  {t("common:IACover.arrendamiento.13")}
                </p>
                <div className="info">
                  <div className="item">
                    <p>{t("common:IACover.arrendamiento.14")}</p>
                    <span className="font-weight-bold">
                      <div style={{ display: "flex", flexFlow: "column" }}>
                        {getData("tribunales")}
                      </div>
                    </span>
                  </div>
                </div>
              </div>

              <div className="row--normal">
                <p className="font-weight-bold">
                  {t("common:IACover.arrendamiento.15")}
                </p>
                <div className="info">
                  <div className="item">
                    <p>{t("common:IACover.arrendamiento.16")}</p>
                    <span className="font-weight-bold">
                      <div style={{ display: "flex", flexFlow: "column" }}>
                        {getData("estacionamiento")}
                      </div>
                    </span>
                  </div>
                  <div className="item">
                    <p>{t("common:IACover.arrendamiento.17")}</p>

                    <div style={{ display: "flex", flexFlow: "column" }}>
                      {getData("mascotas")}
                    </div>
                  </div>
                  <div className="item">
                    <p>{t("common:IACover.arrendamiento.18")}</p>
                    <span className="font-weight-bold">
                      <div style={{ display: "flex", flexFlow: "column" }}>
                        {getData("limite_pago")}
                      </div>
                    </span>
                  </div>
                </div>
              </div>
              {/* <div className="row--normal">
                <p className="font-weight-bold">Simbolos</p>
                <div
                  style={{ display: "flex", flexFlow: "column", gap: "20px" }}
                >
                  <Overall clarity={"Alta"} custom={"Claridad Alta"} />
                  <Overall
                    clarity={"Baja/Media"}
                    custom={"Clarida baja/media"}
                  />
                  <Overall clarity={"La respuesta varia"} />
                </div>
              </div> */}
            </div>
            <div></div>
          </div>
        </div>
      ) : (
        tipo === "compraventa" && (
          <div className="IACover" id="IACover--compraventa">
            <div className="IACover--header">
              <h3>{t("common:IACover.subtitle")}</h3>
              <img src={Logo} />
            </div>
            <div className="IACover--info">
              <div className="row1">
                <div className="info1">
                  <div className="item">
                    <p className="font-weight-bold">
                      {t("common:IACover.text.0")}
                    </p>
                    <div style={{ display: "flex", flexFlow: "column" }}>
                      {getData("tipo")}
                    </div>
                  </div>
                </div>
              </div>
              <div className="row--contractParts">
                <p className="font-weight-bold">
                  {t("common:IACover.compraventa.1")}
                </p>
                <div className="info">
                  <div className="item">
                    <div className="col1">
                      <p>{t("common:IACover.compraventa.2")}</p>
                      <div style={{ display: "flex", flexFlow: "column" }}>
                        {getData("comprador")}
                      </div>
                    </div>
                    <div className="col2">
                      <p>{t("common:IACover.compraventa.4")}</p>
                      <div style={{ display: "flex", flexFlow: "column" }}>
                        {getData("rep_comprador")}
                      </div>
                    </div>
                  </div>
                  <div className="item">
                    <div className="col1">
                      <p>{t("common:IACover.compraventa.3")}</p>
                      <div style={{ display: "flex", flexFlow: "column" }}>
                        {getData("vendedor")}
                      </div>
                    </div>
                    <div className="col2">
                      <p>{t("common:IACover.compraventa.5")}</p>
                      <div style={{ display: "flex", flexFlow: "column" }}>
                        {getData("rep_vendedor")}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="row--normal">
                <div className="info">
                  <div className="item item--adress">
                    <p className="font-weight-bold">
                      {t("common:IACover.compraventa.6")}
                    </p>
                    <div style={{ display: "flex", flexFlow: "column" }}>
                      {getData("confidencialidad")}
                    </div>
                  </div>
                  <div className="item">
                    <p className="font-weight-bold">
                      {t("common:IACover.compraventa.7")}
                    </p>
                    <div style={{ display: "flex", flexFlow: "column" }}>
                      {getData("escrituración")}
                    </div>
                  </div>
                  <div className="item">
                    <p className="font-weight-bold">
                      {t("common:IACover.compraventa.8")}
                    </p>
                    <div style={{ display: "flex", flexFlow: "column" }}>
                      {getData("monto")}
                    </div>
                  </div>
                </div>
              </div>
              {/* <div className="row--normal">
                <p className="font-weight-bold">Simbolos</p>
                <div
                  style={{ display: "flex", flexFlow: "column", gap: "20px" }}
                >
                  <Overall clarity={"Alta"} custom={"Claridad Alta"} />
                  <Overall
                    clarity={"Baja/Media"}
                    custom={"Clarida baja/media"}
                  />
                  <Overall clarity={"La respuesta varia"} />
                </div>
              </div> */}
            </div>
            <div></div>
          </div>
        )
      )}
    </div>
  );
}
export function Overall({ clarity, custom }) {
  return (
    <div className="IATAB--overall">
      <img
        src={
          clarity === "Alta"
            ? alta
            : clarity === "La respuesta varia"
            ? media
            : clarity === "Baja/Media" && baja
        }
        alt=""
        width={30}
        height={30}
        style={{ marginRight: "5px" }}
      />
      <span>{custom ? custom : clarity}</span>
    </div>
  );
}
function NA() {
  return <span style={{ color: "red" }}>N/A</span>;
}

export default IACover;
